/*
 * Task-pane entry point — office-365-taskpane
 * Detects the Office host and delegates to the appropriate host strategy.
 */

/* global document, Office */

import { createHostStrategy } from "./hosts/host-factory";

Office.onReady(async (info) => {
  const strategy = createHostStrategy(info.host);
  if (strategy) {
    document.getElementById("sideload-msg")!.style.display = "none";
    await strategy.init();
  }
});
